import { FileText, Users, Building, Shield } from "lucide-react";
import { ProcessPhase } from "./types";
import { ChecklistIcon, RupeeIcon, PhotoLibraryIcon, SearchUserIcon, DoorbellIcon, MegaphoneIcon } from "./icons";

export const SellerJourneyPhases: ProcessPhase[] = [
	{
		title: "Onboarding",
		steps: [
			{ icon: <ChecklistIcon />, title: "Basic Details" },
			{ icon: <RupeeIcon />, title: "Fee Confirmation" },
			{ icon: <PhotoLibraryIcon />, title: "Photo Inspection" },
		],
	},
	{
		title: "Sales Operations",
		subtitle: "(Cyclical till sold)",
		steps: [
			{ icon: <SearchUserIcon />, title: "Review" },
			{ icon: <DoorbellIcon />, title: "Buyer Visits" },
			{ icon: <MegaphoneIcon />, title: "Marketing" },
		],
	},
	{
		title: "Settlement and Documentation",
		steps: [
			{ icon: <Users className="w-8 h-8" />, title: "Meeting" },
			{ icon: <FileText className="w-8 h-8" />, title: "Token MOU" },
			{ icon: <Building className="w-8 h-8" />, title: "Legal & Loan" },
			{ icon: <Shield className="w-8 h-8" />, title: "Closure" },
		],
	},
];
